import React from 'react';
import { Row, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const Moment = require('moment');
const filter = require('lodash/filter');
const find = require('lodash/find');
const some = require('lodash/sum');

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
const ServerRequest = require('../../actions/request');

const SignInStore = require('../../stores/SignInStore');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
import SuccessBox from '../common/SuccessBox';
import LoadingSpinner from '../loading/LoadingSpinner';
import EmailAvailabilityChecker from '../common/EmailAvailabilityChecker';

import MainNav from '../nav/MainNav';

const propTypes = {

};

const defaultProps = {

};

class OrganizationSubscriptionView extends React.Component {
    constructor(props) {
        super(props);

        const planStoreState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState());

        this.state = {
            signInStoreState: SignInStore.getState(),
            updating_plan: false,
            planChangeSuccess: false,
            subscribe_error: null,
            subscirbe_warning: null,
            createOrgActionId: null,
            upgradeActionId: null,
            ...planStoreState,
            orgName: '',
            orgEmail: '',
            orgEmailValidated: false
        };

        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);
        this.onOrgNameChange = this.onOrgNameChange.bind(this);
        this.onOrgEmailChange = this.onOrgEmailChange.bind(this);
        this.onOrgEmailValidated = this.onOrgEmailValidated.bind(this);

        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        SubscriptionPlanActions.getUpgradePlans(uuid.v4());
        SubscriptionPlanActions.getOwnedOrgSubscriptions(uuid.v4());
        // SubscriptionPlanActions.getProrateData(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreChange(newState) {
        this.setState({ signInStoreState: newState });
    }

    onSubscriptionPlanStoreChange(newState) {
        const planStoreState = this.getStateFromPlanStoreState(newState);

        let additionalState = {};
        const action = newState.action;
        if (action.id === this.state.createOrgActionId) {
            if (!action.error) {
                additionalState = { ...additionalState, createOrgActionId: null, planChangeSuccess: true, subscribe_error: null, subscirbe_warning: null, updating_plan: false };
            }
            else {
                additionalState = { ...additionalState, createOrgActionId: null, subscribe_error: action.error, updating_plan: false };
            }
        }
        else if (action.id === this.state.upgradeActionId) {
            if (!action.error) {
                if (action.sessionId) {
                    console.log("stripe embedded mode not supported"); // This shouldn't happen (but leaving this hook here in case we want to use embedded mode)
                    this.setState({
                        subscribe_warning: {
                            message: 'Transaction cancelled'
                        }
                    });
                }
                else if (action.sessionUrl) {
                    // hosted mode when we can't redirect from the server due to CORS
                    console.log("redirecting for session"); // FIXME: remove debug spam
                    window.location.href = action.sessionUrl;
                }
                else {
                    additionalState = { ...additionalState, upgradeActionId: null, planChangeSuccess: true, subscribe_error: null, subscribe_warning: null, updating_plan: false };
                }
            }
            else {
                additionalState = { ...additionalState, upgradeActionId: null, subscribe_error: action.error, updating_plan: false };
            }
        }

        this.setState({ ...planStoreState, ...additionalState });
    }

    onOrgEmailChange(email) {
        this.setState({ orgEmail: email, orgEmailValidated: false });
    }

    onOrgNameChange(e) {
        this.setState({ orgName: e.target.value });
    }

    getStateFromPlanStoreState(state) {
        var org_plans = filter(state.upgrade_plans, plan => {
            return Globals.users.is_org_account_type(plan.account_type) && ( plan.process_type === Globals.ecommerce.process_types.CC);
        });

        return {
            org_plans: org_plans,
            // plan_prorate_data: state.plan_prorate_data,
            owned_org_subscriptions: state.owned_org_subscriptions
        };
    }

    handleChangeSubscriptionPromise=(plan_id,proration_date)=>{
        const currentPath = window.location.pathname;
        let success_url = `${GlobalConfig.ApiUrl}${currentPath}?update=success`;
        let cancel_url = `${GlobalConfig.ApiUrl}${currentPath}?update=cancel`;

        const upgradeActionId = uuid.v4();
        this.setState({ upgradeActionId, updating_plan: true },()=>{
            return SubscriptionPlanActions.changeSubscriptionPlan(upgradeActionId, {
                plan_id,
                proration_date, // Supply this so that what we tell the user matches what stripe calculates
                success_url,cancel_url,
            });
        });
    }

    doChangePlan=(planId, e)=>{
        e.stopPropagation();
        const self = this;

        const selectedPlan = find(this.state.user_plans, {id: planId});
        if (!selectedPlan) {
            this.setState({
                subscribe_error: {
                    message: 'Error looking up selected plan!'
                }
            });
            return;
        }

        const description = `Purchase ${selectedPlan.display_name}`
        this.handleChangeSubscriptionPromise(selectedPlan.id)
        
    } // doChangePlan

    onOrgEmailValidated() {
        this.setState({ orgEmailValidated: true });
    }

    render() {
        if (!this.state.signInStoreState.initialized) {
            return null;
        }

        const userInfo = this.state.signInStoreState.userInfo;
        const teamPlans = this.state.org_plans.filter(plan => plan.account_type === Globals.users.account_types.SCHOOL);
        const enterprisePlans = this.state.org_plans.filter(plan => plan.account_type === Globals.users.account_types.ENTERPRISE);
        const anyUnpaidOrgs = some( this.state.owned_org_subscriptions, orgSub => {
            return [Globals.ecommerce.subscription_statuses.unpaid, Globals.ecommerce.subscription_statuses.past_due].indexOf(orgSub.subscription_status) >= 0;
        });

        const canPurchase = !anyUnpaidOrgs && !!this.state.orgEmail && this.state.orgEmailValidated;

        return (
            <div className="view-wrapper orgSubscriptionView">
                {(!!this.state.creating_org) &&
                    <div className="full-screen-blocker text-centered">
                        <LoadingSpinner className="font-size-15rem rel-centered-v" />
                    </div>
                }

                <MainNav rootChannel={userInfo.id}/>

                <div className="container-fluid">
                    <ErrorBox error={this.state.subscribe_error} />
                    {this.state.subscribe_warning ?
                        <WarningBox>{this.state.subscribe_warning}</WarningBox>
                    : null }

                    {(!!anyUnpaidOrgs) &&
                        <WarningBox className="margin-top-lg">You cannot purchase new Institutional License while you own an Institutional Licese that is marked as Unpaid or Past Due</WarningBox>
                    }

                    {(!!this.state.planChangeSuccess) &&
                        <SuccessBox className="margin-top-lg">Your license has been updated.</SuccessBox>
                    }

                    <Row>
                        <div className="tile-dash-floating margin-top-lg margin-bottom-lg col-12 col-lg-8 offset-lg-2">
                            <h1 className="font-size-xl text-centered">Institutional Licenses</h1>
                            <hr/>
                            <div className="biColumnRow">
                                <div className="biColumnRow__left text-centered">
                                    <img src={`${GlobalConfig.StaticUrl}/img/screens/analytics_view_400.jpg`} alt="Analytics View"/>
                                </div>
                                <div className="biColumnRow__right text-centered">
                                    <div className="text-left margin-bottom-lg">
                                        <h2 className="margin-bottom-md">An Institutional License allows your team to:</h2>
                                        <ul className="benefit-list">
                                            <li>Integrate with any LTI-based LMS</li>
                                            <li>Manage teams in Author</li>
                                            <li>Manage your content</li>
                                            <li>Track student data</li>
                                        </ul>
                                    </div>
                                    <div className="text-left">
                                        <h2 className="margin-bottom-md">Get started here</h2>
                                        <EmailAvailabilityChecker
                                            id="org-email-check"
                                            label="institution contact email"
                                            onChange={this.onOrgEmailChange}
                                            value={this.state.orgEmail}
                                            onValidated={this.onOrgEmailValidated}
                                        />
                                        <Form.Group controlId={this.props.id}>
                                            <Form.Label>institution name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                aria-label="email address"
                                                value={this.state.orgName}
                                                onChange={this.onOrgNameChange}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        <div className="tile-dash-floating margin-top-lg margin-bottom-lg col-12 col-lg-8 offset-lg-2">
                            <ul className="subBlockList">
                                {   this.state.org_plans.map(plan => {
                                        return (
                                            <li key={plan.id} className="subBlock">
                                                {<h3 className="subBlock__header">{plan.display_name}</h3>}
                                                <div className="subBlock__body">
                                                    <ul className="margin-bottom-lg">
                                                        <li><span className="font-size-xl">{StringUtil.formatUSD(plan.cost)}</span> / {plan.interval}</li>
                                                        <li># Students</li>
                                                    </ul>
                                                    <div>
                                                        <div className="subBlock__buttonRow">
                                                            <Button
                                                                disabled={this.creating_org || !canPurchase}
                                                                onClick={ (e)=>{ this.doChangePlan(plan.id,e)} }
                                                            >
                                                                Buy Now
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })
                                }
                                <li key="gold" className="subBlock">
                                    {<h3 className="subBlock__header">Gold</h3>}
                                    <div className="subBlock__body">
                                        <ul className="margin-bottom-lg">
                                            <li><span className="font-size-xl">Unlimited Students</span></li>
                                        </ul>
                                        <div>
                                            For more info, contact <a href="mailto:sales@muzzylane.com">sales@muzzylane.com</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}

OrganizationSubscriptionView.propTypes = propTypes;
OrganizationSubscriptionView.defaultProps = defaultProps;

export default OrganizationSubscriptionView;